export default {
    tooltip: 'Start user excel export'
}
